import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=0bb66594&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=0bb66594&prod&lang=less"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=0bb66594&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb66594",
  null
  
)

export default component.exports